import React from 'react';
import { processData } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const Process = () => {
  return (
    <section id="process" className="py-24 lg:py-32 bg-black relative overflow-hidden">
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        
        {/* Section Title */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            {processData.sectionTitle}
          </h2>
          <div className="w-20 h-1 bg-accent-red mx-auto"></div>
        </div>

        {/* Process Steps */}
        <div className="max-w-5xl mx-auto space-y-6 lg:space-y-8">
          {processData.steps.map((step, index) => (
            <div key={step.id}>
              <div className="bg-gradient-to-r from-gray-900/80 to-black/80 backdrop-blur-sm border border-gold/10 rounded-2xl p-8 lg:p-10 hover:border-gold/30 transition-all group">
                <div className="flex flex-col lg:flex-row lg:items-center gap-6">
                  
                  {/* Step Number */}
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 lg:w-20 lg:h-20 bg-gradient-to-br from-gold to-yellow-600 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform">
                      <span className="text-black font-bold text-2xl lg:text-3xl">
                        {step.number}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <h3 className="text-xl lg:text-2xl font-bold text-white mb-3 group-hover:text-gold transition-colors">
                      {step.title}
                    </h3>
                    <p className="text-white/70 leading-relaxed text-base lg:text-lg">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>

              {/* Arrow between steps */}
              {index < processData.steps.length - 1 && (
                <div className="flex justify-center py-4">
                  <ArrowRight className="text-gold/40" size={24} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
